import React from 'react'
import { LogOut, Package } from 'lucide-react'

interface HeaderProps {
  title: string
  showLogout?: boolean
  onLogout?: () => void
}

const Header: React.FC<HeaderProps> = ({ title, showLogout, onLogout }) => {
  return (
    <header className="bg-white border-b border-gray-200 px-4 py-4 sticky top-0 z-10">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
            <Package size={18} className="text-white" />
          </div>
          <h1 className="text-lg font-semibold text-gray-900">{title}</h1>
        </div>
        {showLogout && onLogout && (
          <button
            onClick={onLogout}
            className="p-2 text-gray-500 hover:text-gray-700"
          >
            <LogOut size={20} />
          </button>
        )}
      </div>
    </header>
  )
}

export default Header
